export const SNOWPLOW_APP_ID = 'montu-au.alternaleaf-patient';
export const SNOWPLOW_TRACKER_NAME = 'hoc.patient-portal';
